import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import MaterialTable, { MTableCell } from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import useWindowDimensions from '../../../../../features/events-and-classes/utils/useWindowDimensions';
import { fetchOpenEventsData } from '../api';
import { toast } from '../../../../../redux/actions/UI';
import { Container } from './OpenActivityTable.styled';
import { getLatestOpenDate } from '../utils';
import OpenPanel from './OpenPanel/OpenPanel';

const columns = [
  {
    field: 'email',
    title: 'Contact',
    width: '50%',
    defaultSort: 'asc',
  },
  {
    field: 'totalOpens',
    title: 'Total Opens',
    width: '15%',
  },
  {
    field: 'latestOpenDate',
    title: 'Last Opened Date',
    width: '30%',
  },
];

const OpenActivityTable = ({
  messageId,
  rows,
  setRows,
  isLoading,
  setLoading,
  orgId,
}) => {
  const [contactOpenActivityMap, setContactOpenActivityMap] = useState({});
  const { height } = useWindowDimensions();
  const dispatch = useDispatch();

  const theme = createMuiTheme({
    palette: {
      secondary: {
        main: '#1890FF',
      },
    },
  });

  useEffect(() => {
    fetchEvents();
  }, [messageId]);

  const fetchEvents = async () => {
    try {
      setLoading(true);

      const data = await fetchOpenEventsData({
        messageId,
        orgId,
      });
      const tableRows = [];
      for (const email in data.openEvents) {
        const contactLatestOpenDate = getLatestOpenDate(data.openEvents[email]);
        const contactOpenEventData = data.openEvents[email];
        const contactId = contactOpenEventData[0].contactId;
        const contactData = data.memberOpenEventsMap[contactId];

        tableRows.push({
          _id: email,
          email,
          totalOpens: contactOpenEventData.length,
          latestOpenDate: contactLatestOpenDate || 'N/A',
          openEvents: contactOpenEventData,
          fullName: contactData
            ? contactData.firstName + ' ' + contactData.lastName
            : '',
          m1_id:
            contactData?.organization?.attributes?.find(
              attr => attr.name === 'memberNRDSID'
            )?.value || 'N/A',
          memberId: contactData?.source?.memberId || 'N/A',
          phone: contactData?.phoneNumber || 'N/A',
        });
      }

      setLoading(false);
      setRows(tableRows);
      setContactOpenActivityMap(data.openEvents);
    } catch (e) {
      console.error(e);
      dispatch(toast('error', 'Failed to fetch open events data'));
    }
  };

  const getEmptyMessage = () => {
    return isLoading ? (
      <>No records to display</>
    ) : (
      <>No open events found for this message.</>
    );
  };

  const detailPanel = ({ email }) => {
    const contactActivity = contactOpenActivityMap[email];
    const sortedOpenEvents = contactActivity.sort((a, b) => a.time - b.time);
    return <OpenPanel contactOpenActivity={sortedOpenEvents} />;
  };

  return (
    <Container>
      <MuiThemeProvider theme={theme}>
        <MaterialTable
          isLoading={isLoading}
          components={{
            Cell: props => <MTableCell {...props} />,
          }}
          detailPanel={data => detailPanel(data)}
          columns={columns}
          data={rows}
          options={{
            showTitle: false,
            search: false,
            pageSize: Math.round((height - 300) / 48),
            toolbar: false,
            headerStyle: {
              fontWeight: 'bold',
            },
            pageSizeOptions: [],
            tableLayout: 'fixed',
          }}
          onRowClick={(e, data, togglePanel) => {
            togglePanel();
          }}
          localization={{
            body: {
              emptyDataSourceMessage: getEmptyMessage(),
            },
          }}
        />
      </MuiThemeProvider>
    </Container>
  );
};

export default OpenActivityTable;
